import React from "react";
import classnames from "classnames";

import { Clear } from "components/Icons";

import "./style.scss";

const ModalBox = ({ children, visible, onCloseModal }) => (
  <div className={classnames("modal-container", { visible })}>
    <div className="modal-box">
      <div className="modal-header" onClick={onCloseModal}>
        <Clear />
      </div>
      <div className="modal-body">{children}</div>
    </div>
  </div>
);

export default ModalBox;
